export default __webpack_public_path__ + "static/26-1c232f8e80c1773cefb3df465c57fc70.webp";